var _animateTransform;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWithdrawing = function SvgWithdrawing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22 10.76a.86.86 0 0 0-.86-.86H2.86c-.48 0-.86.38-.86.86 0 5.89 4.11 10 10 10s10-4.12 10-10Z",
    fill: "#fff",
    style: {
      fill: "var(--fillg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.53 3.46 2.85 2.84c.29.29.29.77 0 1.06-.29.29-.77.29-1.06 0L12.75 5.8v9.57c0 .41-.34.75-.75.75s-.75-.34-.75-.75V5.8L9.69 7.37c-.29.29-.77.29-1.06 0a.753.753 0 0 1-.23-.53c0-.19.07-.38.22-.53l2.85-2.84c.29-.3.77-.3 1.06-.01Z",
    fill: "#fff",
    style: {
      fill: "var(--fillg)"
    }
  }, _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "translate",
    from: "0 0",
    to: "0 -10",
    dur: "1s",
    additive: "sum",
    repeatCount: "indefinite",
    keyTimes: "0; 0.5; 1",
    values: "0 0; 0 -5; 0 -10"
  }))));
};
export default SvgWithdrawing;